import React from "react";
import defaultStyle from "../../../utils/default";

// Component to render text on screen
function Text({ text, color, index }) {
  const isSolid = color?.elements?.style === "Solid"; //Solid true

  const borderRaduses =
    color?.elements?.shape  === "Pill"
      ? "16px"
      : color?.elements?.shape  === "Rounded"
      ? "16px"
      : "0px";

  return (
    <div
    key={index}
      style={{
        height: "auto",
        marginTop:"8px",
        borderRadius: borderRaduses,
        backgroundColor: "white",
        background: isSolid && (color?.color?.secondary || defaultStyle.color.secondary ),
        border: !isSolid && `2px solid ${color?.color?.primary || defaultStyle.color.primary } `
      }}
    >
      <p
        style={{
          fontSize: "14px",
          fontWeight: 500,
          color: color?.color?.primary || defaultStyle.color.primary,
          padding: "1rem",
          lineHeight: "24px",
          margin:"10px auto"
        }}
      >
        {text}
      </p>
    </div>
  );
}

export default Text;
